import firebase from "../firebase";
import IFontData from "../types/font.type"

const db = firebase.firestore().collection("/fonts");

class FontDataService {
  getAll() {
    return db;
  }

  create(font: IFontData) {
    return db.add(font);
  }

  update(id: string, value: any) {
    return db.doc(id).update(value);
  }

  delete(id: string) {
    return db.doc(id).delete();
  }
}

const fontDataService = new FontDataService();

export default fontDataService;
